(function () {
  if (typeof customElements === "undefined" || customElements.get("sliding-panels")) return;

  class SlidingPanels extends HTMLElement {
    connectedCallback() {
      this._panels = Array.from(this.querySelectorAll(":scope > sliding-panel"));
      if (!this._panels.length) return;

      const raw = parseInt(String(this.getAttribute("initial-open") || "1"), 10);
      const start =
        Number.isFinite(raw) && raw >= 1 && raw <= this._panels.length ? raw : 1;
      this.openPanel(start);

      this.addEventListener("click", (e) => {
        if (e.target.closest("a, button")) return;
        const panel = e.target.closest("sliding-panel");
        if (!panel || !this.contains(panel)) return;
        if (panel.getAttribute("expanded") === "true") return;
        const idx = this._panels.indexOf(panel) + 1;
        this.openPanel(idx);
      });
    }

    openPanel(index1) {
      this._panels.forEach((p, i) => {
        p.setAttribute("expanded", i + 1 === index1 ? "true" : "false");
      });
    }
  }

  customElements.define("sliding-panels", SlidingPanels);
})();
